// Универсальный показ ошибки API через bootstrap-vue toast (справа внизу,
// красный). Понимает форматы тела ответа, которые встречаются в приложении:
//  - { error: "текст" }                       - ApplicationController#render_application_error
//  - { errors: "текст" | ["текст", ...] }      - контроллеры, отдающие ошибки списком
//  - { field: ["message", ...], ... }          - ActiveModel errors (render json: model.errors)
//
// Использование в .fail(...)-хендлере jQuery.ajax:
//   .fail(function(jqXHR) { show_api_error(vc, jqXHR); })
// Первым аргументом — компонент; вне компонента (store/api) допустим null — тогда тост
// показывается через корневой инстанс, зарегистрированный паком (set_toast_host).
//
// Модуль сознательно не импортирует Vue: он попадает в бандл через store/api, и лишний
// импорт Vue здесь ломает инициализацию bootstrap-vue в паке site (модалки перестают
// рендериться) — хост приходит снаружи.

function extract_error_message(jqXHR) {
  const body = jqXHR && jqXHR.responseJSON;

  if (!body) {
    return null;
  }

  if (typeof body.error === 'string') {
    return body.error;
  }

  if (body.errors) {
    const messages = [].concat(body.errors).join(' ');
    if (messages.length) {
      return messages;
    }
  }

  if (typeof body === 'object') {
    const parts = Object.keys(body).map((field) => {
      const messages = [].concat(body[field]).join(', ');
      return field === 'base' ? messages : `${field}: ${messages}`;
    });
    if (parts.length) {
      return parts.join('; ');
    }
  }

  return null;
}

// Корневой инстанс приложения — его регистрирует пак (packs/application.js, packs/site.js),
// чтобы вызовы вне компонента тоже могли показать тост
let root_host = null;

export function set_toast_host(vm) {
  root_host = vm;
}

function toast_host(vm) {
  return (vm && vm.$bvToast) ? vm : root_host;
}

export function show_api_error(vm, jqXHR, opts = {}) {
  const status = jqXHR && jqXHR.status;
  const message = extract_error_message(jqXHR) || 'Произошла ошибка при выполнении запроса.';

  console.error('API error', status, message, jqXHR);

  const host = toast_host(vm);
  if (!host || !host.$bvToast) {
    return;
  }

  // $bvToast - сервис bootstrap-vue (Vue.use(BootstrapVue) в packs/application.js
  // и packs/site.js), добавленный на прототип Vue, поэтому доступен как vm.$bvToast
  // в любом компоненте: https://bootstrap-vue.org/docs/components/toast
  host.$bvToast.toast(message, {
    title: status ? `Ошибка ${status}` : 'Ошибка',
    variant: 'danger',
    toaster: 'b-toaster-bottom-right',
    solid: true,
    autoHideDelay: 8000,
    appendToast: true,
    ...opts,
  });
}
